const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
/* ===== Autoplay MP4 on scroll (supports deferred-media) ===== */
(function () {
  const THRESHOLD = 0.6;

  function tryPlayVideo(video) {
    if (!video) return;

    // Autoplay requirements
    video.muted = true;
    video.setAttribute("muted", "");
    video.playsInline = true;
    video.setAttribute("playsinline", "");
video.removeAttribute("controls");
video.controls = false;
    // Some themes need this to start reliably
    video.setAttribute("preload", "metadata");

    try {
      if (video.readyState === 0) video.load();
      const p = video.play();
      if (p && typeof p.catch === "function") p.catch(() => {});
    } catch (e) {}
  }

  function loadDeferredMedia(deferredEl) {
    if (!deferredEl) return;

    // Dawn + many themes: custom element has loadContent()
    if (typeof deferredEl.loadContent === "function") {
      try { deferredEl.loadContent(); } catch (e) {}
      return;
    }

    // Fallback: click the poster/play button inside deferred-media
    const btn =
      deferredEl.querySelector("button") ||
      deferredEl.querySelector('[role="button"]') ||
      deferredEl.querySelector(".deferred-media__poster") ||
      deferredEl.querySelector("[data-deferred-media-button]");
    if (btn) btn.click();
  }

  function handleEntry(entry) {
    const target = entry.target;

    if (entry.isIntersecting && entry.intersectionRatio >= THRESHOLD) {
      // If we’re observing a deferred-media wrapper, load it first
      if (target.tagName && target.tagName.toLowerCase() === "deferred-media") {
        loadDeferredMedia(target);

        // Give the theme a moment to inject the real <video>
        setTimeout(() => {
          const v = target.querySelector("video");
          tryPlayVideo(v);
        }, 200);
        return;
      }

      // If we’re observing a normal <video>
      if (target.tagName && target.tagName.toLowerCase() === "video") {
        tryPlayVideo(target);
        return;
      }

      // If we’re observing a container, find a video inside
      const v = target.querySelector && target.querySelector("video");
      tryPlayVideo(v);
    } else {
      // Pause when offscreen
      const v =
        (target.tagName && target.tagName.toLowerCase() === "video" && target) ||
        (target.querySelector && target.querySelector("video"));
      if (v) v.pause();
    }
  }

  function bind() {
    const toObserve = [
      ...document.querySelectorAll("deferred-media"),
      ...document.querySelectorAll("video"),
    ];

    const io = new IntersectionObserver((entries) => {
      entries.forEach(handleEntry);
    }, { threshold: [0, 0.25, THRESHOLD, 0.75, 1] });

    toObserve.forEach((el) => {
      if (el.dataset.autoplayOnScrollInit === "1") return;
      el.dataset.autoplayOnScrollInit = "1";
      io.observe(el);
    });
  }

  // Run now + on editor section loads
  bind();
  document.addEventListener("DOMContentLoaded", bind);
  document.addEventListener("shopify:section:load", bind);

  // Catch late-injected media (common)
  let tries = 0;
  const t = setInterval(() => {
    bind();
    tries += 1;
    if (tries > 20) clearInterval(t); // ~10s
  }, 500);
})();